export default "__VITE_PUBLIC_ASSET__ff63b0d7__"